<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-card>
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->
                <v-btn to="/content" rounded color="#A5668B" class="text-white">
                  <v-icon>mdi-backspace-reverse-outline</v-icon>
                  بازگشت
                </v-btn>
                <v-spacer/>
                افزودن محتوا
                <v-spacer/>
                <v-btn @click="editContent" color="#50858B" rounded
                       class="text-white">
                  <v-icon>mdi-content-save</v-icon>
                  ذخیره
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>


              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-text-field
                        :rules="rules.title"
                        v-model="title"
                        :error-messages="errors.name"
                        autofocus
                        label="عنوان"
                        required
                        outlined
                        dense
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-select
                        v-model="service"
                        :rules="rules.service"
                        :items="services"
                        :error-messages="errors.service"
                        item-text="nameLand"
                        item-value="id"
                        label="انتخاب سرویس"
                        outlined
                        dense
                        return-object
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-select
                        v-model="type"
                        :rules="rules.type"
                        :items="types"
                        :error-messages="errors.type"
                        item-text="value"
                        item-value="name"
                        label="نوع محتوا"
                        outlined
                        dense
                        return-object
                    ></v-select>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-text-field
                        v-model="link"
                        :error-messages="errors.link"
                        label="پیوند"
                        outlined
                        dense
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-text-field
                        v-model="sortOrder"
                        :rules="rules.name"
                        label="اولویت نمایش"
                        :error-messages="errors.sort_order"
                        outlined
                        dense
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                    <v-file-input
                        v-model="picture"
                        label="تصویر محتوا"
                        :error-messages="errors.picture"
                        outlined
                        dense
                        append-icon="mdi-camera"
                    ></v-file-input>

                  </v-flex>
                </v-row>
                <v-row>
                  <v-container fluid>
                    <ckeditor :editor="editor.editor" v-model="description" :config="editor.editorConfig">

                    </ckeditor>
                  </v-container>

                </v-row>

              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {

  props: ["id"],
  data() {
    return {
      type: '',
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        }
      },
      service: null,
      services: [],
      query: {sort: 'id', order: 'desc', limit: 100, s: ''},
      rules: {
        title: [val => (val || '').length > 0 || 'فیلد عنوان الزامی می باشد'],
        services: [val => val.length > 0 || 'فیلد سرویس الزامی می باشد'],
        type: [val => (val || '').length > 0 || 'فیلد نوع محتوا الزامی می باشد'],
      },
      types: [
        {name: 'popup', value: 'پاپ اپ'},
        {name: 'header', value: 'سربرگ'},
        {name: 'news', value: 'اخبار'},
        {name: 'tag', value: 'برچسب'},
        {name: 'banner', value: 'بنر'},
        {name: 'support_link', value: 'پیوند پشتیبانی'},
        {name: 'company_links', value: 'پیوند شرکت'},
        {name: 'useful_links', value: 'پیوند های مفید'},
        {name: 'brand', value: 'برند'},
      ],
      title: '',
      description: '',
      picture: [],
      link: '',
      sortOrder: '',
      errors: [],
    }
  },

  mounted() {
    this.keydown('editContent')
    this.services = this.getService().data
    this.getContent();
    this.$store.dispatch(SET_BREADCRUMB, [{title:this.$route.meta.title}])


  },
  methods: {

    editContent() {
      if (this.service == null) {
        return this.$toast.error('لطفا سرویس را انتخاب کنید')
      }
      if (this.type == null) {
        return this.$toast.error('لطفا نوع محتوا را انتخاب کنید.')
      }
      let formData = new FormData();
      formData.append('service_id', this.service.id)
      formData.append('type', this.type.name)
      formData.append('title', this.title)
      formData.append('description', this.description)
      formData.append('picture', this.picture)
      formData.append('link', this.link)
      formData.append('sort_order', this.sortOrder)
      formData.append('_method', 'PUT')
      this.requestApiPost(`content/${this.id}`, formData, this.configurationFile()).then(response => {
        this.$toast.success('نقش با موفقیت اضافه شد')
        this.goReplace('content')
      }).catch(e => {
        this.errors = e.response.data.errors
      })

    },
    getContent() {
      this.requestApiGet(`content/${this.id}`).then(({data}) => {

        this.title = data.title
        this.description = data.description
        // this.picture = data.picture
        this.link = data.link
        this.sortOrder = data.sort_order
        this.service = data.service_id
        this.type = data.type

        /*this.roleEdit.permissions.forEach(permission => {
            this.permissions.push(permission.id)
        })*/
      })
    },
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters('ContentIndex', ['contents', 'total', 'loading']),
  }
}
</script>
